import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, Search, Check } from 'lucide-react';
import CompanyLogo from './CompanyLogo';

function CompanyDropdown({ companies, activeCompanies, toggleCompany }) {
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const normalizedCompanies = companies
    .map(c => (typeof c === 'string' ? { name: c } : c))
    .filter(c => c?.name)
    .sort((a, b) => a.name.localeCompare(b.name));
  const filtered = normalizedCompanies
    .filter(c => c.name.toLowerCase().includes(query.trim().toLowerCase()))
    .slice(0, 40);

  const label = activeCompanies.length === 1
    ? activeCompanies[0]
    : activeCompanies.length > 1
      ? `${activeCompanies.length} companies`
      : 'All Companies';

  return (
    <div className={`relative ${open ? 'z-50' : 'z-10'}`} ref={ref}>
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        className={`flex items-center gap-2 h-8 text-[13px] font-medium border rounded-md px-3 transition ${
 open || activeCompanies.length > 0
 ? 'border-[#1c4ed8] bg-[#e7edfc] text-[#1c4ed8]'
 : 'border-[#cbd3df] bg-white text-[#0d1524] hover:bg-[#f6f7fa]'
 }`}
      >
        {activeCompanies.length === 1 && <CompanyLogo name={activeCompanies[0]} size="xs" />}
        <span className="truncate max-w-[150px]">{label}</span>
        <ChevronDown size={14} className={`transition flex-shrink-0 ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="absolute top-full left-0 mt-2 w-72 bg-white border border-[#e1e5ec] rounded-lg shadow-xl z-50 overflow-hidden">
          <div className="p-2 border-b border-[#e1e5ec]">
            <div className="flex items-center gap-2 bg-[#f6f7fa] border border-[#e1e5ec] rounded-lg px-3 py-2">
              <Search size={14} className="text-[#76829a] flex-shrink-0" />
              <input
                type="text"
                placeholder="Search companies…"
                value={query}
                onChange={e => setQuery(e.target.value)}
                autoFocus
                className="w-full min-w-0 bg-transparent text-[13px] focus:outline-none focus:border-[#1c4ed8] h-8"
              />
            </div>
          </div>
          <div className="max-h-64 overflow-y-auto py-1">
            {filtered.map(c => {
              const active = activeCompanies.includes(c.name);
              return (
                <button
                  type="button"
                  key={c.name}
                  onClick={() => toggleCompany(c.name)}
                  className={`w-full px-3 py-3 flex items-center gap-2.5 text-left transition ${
 active ? 'bg-[#e7edfc] text-[#1c4ed8]' : 'text-[#0d1524] hover:bg-[#f6f7fa]'
 }`}
                >
                  <span className={`h-4 w-4 rounded border flex items-center justify-center flex-shrink-0 ${
 active ? 'bg-[#1c4ed8] border-[#1c4ed8] text-white' : 'border-[#cbd3df]'
 }`}>
                    {active && <Check size={10} />}
                  </span>
                  <CompanyLogo name={c.name} size="sm" />
                  <span className="company-label truncate">{c.name}</span>
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default CompanyDropdown;